var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.42565 15.2253C1.26732 15.2253 1.10898 15.1669 0.983984 15.0419C0.742318 14.8003 0.742318 14.4003 0.983984 14.1586L6.41732 8.72526C6.81732 8.32526 6.81732 7.67526 6.41732 7.27526L0.983984 1.84193C0.742318 1.60026 0.742318 1.20026 0.983984 0.958594C1.22565 0.716927 1.62565 0.716927 1.86732 0.958594L7.30065 6.39193C7.72565 6.81693 7.96732 7.39193 7.96732 8.00026C7.96732 8.60859 7.73398 9.18359 7.30065 9.60859L1.86732 15.0419C1.74232 15.1586 1.58398 15.2253 1.42565 15.2253Z",
    fill: "#1B75BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.cc40890eec35e6139e303ace27d9dd6f.svg";
export { ForwardRef as ReactComponent };